import React from 'react';
import { DatePicker } from 'antd';

const CustomDatePicker = ({ style, ...props }) => {
  const datePickerStyle = {
    width: '100%',
    fontSize: '12px',
    ...style
  };

  return (
    <DatePicker
      style={datePickerStyle}
      className="custom-date-picker"
      {...props}
    />
  );
};

// Add CSS for the DatePicker input
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  .custom-date-picker .ant-picker-input > input {
    font-size: 12px !important;
  }
`;
if (!document.head.querySelector('style[data-custom-datepicker]')) {
  styleSheet.setAttribute('data-custom-datepicker', 'true');
  document.head.appendChild(styleSheet);
}

export default CustomDatePicker;